"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var store_1 = __importDefault(require("./store"));
var roles_json_1 = __importDefault(require("../roles.json"));
function commentNode(vnode, element) {
    var comment = document.createComment(" ");
    Object.defineProperty(comment, "setAttribute", {
        value: function () { return undefined; }
    });
    vnode.elm = comment;
    vnode.text = "";
    vnode.isComment = true;
    vnode.context = undefined;
    vnode.tag = undefined;
    vnode.data.directives = undefined;
    if (element.parentNode) {
        element.parentNode.replaceChild(comment, element);
    }
}
vue_1.default.directive("role", function (element, binding, vnode) {
    if (!(store_1.default.state.roles.includes(roles_json_1.default.superAdministrator) ||
        store_1.default.state.roles.includes(binding.value))) {
        commentNode(vnode, element);
    }
});
vue_1.default.directive("permission", function (element, binding, vnode) {
    if (!(store_1.default.state.roles.includes(roles_json_1.default.superAdministrator) ||
        store_1.default.state.permissions.includes(binding.value))) {
        commentNode(vnode, element);
    }
});
vue_1.default.directive("permissions", function (element, binding, vnode) {
    if (typeof binding.value === "undefined") {
        return true;
    }
    if (!Array.isArray(binding.value)) {
        console.error("Using binding value", binding.value, "which should be an array for directive 'permissions'.");
        return false;
    }
    if (!(store_1.default.state.roles.includes(roles_json_1.default.superAdministrator) ||
        binding.value.every(function (value) { return store_1.default.state.permissions.includes(value); }))) {
        commentNode(vnode, element);
    }
});
vue_1.default.directive("click-outside", {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            if (!(el === event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unbind: function (el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
    },
});
function emitEnter(event, vnode) {
    if (event.keyCode === 13) {
        vnode.context.$emit("enter");
    }
}
vue_1.default.directive("enter", {
    bind: function (el, binding, vnode) {
        el.addEventListener("keydown", function (event) { return emitEnter(event, vnode); });
    },
    unbind: function (el) {
        el.removeEventListener("keydown", emitEnter);
    }
});
